import React from "react";

const Card = (props) => {
  const classes = `relative flex flex-col min-w-0 break-words bg-white w-full mb-6 shadow-lg rounded-lg ease-linear transition-all duration-150 ${props.className}`;
  return <div className={classes}>{props.children}</div>;
};

export default Card;
